var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.7007 6.37235L17.0045 4L20.5641 7.45443L18.2604 9.8279L14.7007 6.37235ZM6.92263 14.3827L10.4823 17.8383L17.3384 10.7762L13.779 7.32174L6.92263 14.3827ZM9.56277 18.7865L6.00296 15.3308L4.5 20.2037L9.56277 18.7865Z","fill":"#313031"})));
}

Pen.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Pen;

Pen.default = Pen;
